import { PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import { Dialog, DialogTitle, IconButton, Typography } from '@material-ui/core'
import styled from 'styled-components'

export const Modal = styled(Dialog)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  max-width: unset;
  width: 100%;

  & .MuiDialogContent-root {
    width: 300px;
    padding: 18px 20px 20px 20px;
  }

  & .MuiDialog-paper {
    border-radius: 14px;
  }

  & .MuiDialogTitle-root {
    width: 100%;
  }

  @media (min-width: 520px) {
    & .MuiDialogContent-root {
      width: 400px;
    }
  }

  @media (min-width: 600px) {
    & .MuiDialogContent-root {
      width: 500px;
    }
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
`

export const ModalHeader = styled.h3`
  margin: 0 auto 0 8px;
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grayscale.black};
`

export const ModalSubheader = styled.h4`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.component.buttonLink};
  color: ${({ theme }) => theme.colors.grayscale.black};
  margin-bottom: 25px;
`

export const InstructionRow = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fonts.component.buttonLink};
  color: ${({ theme }) => theme.colors.grayscale.gray40};
  margin-bottom: 24px;
`

export const MissingFormRow = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fonts.component.buttonLink};
  color: ${({ theme }) => theme.colors.grayscale.black};
  margin-bottom: 32px;
  height: 24px;
  padding-left: 24px;
  padding-right: 16px;
`

export const FormName = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.component.buttonLink};
  margin-left: 8px;
`

export const FormTag = styled.div`
  padding: 4px 8px;
  color: ${({ theme }) => theme.colors.grayscale.white};
  background-color: ${({ theme }) => theme.colors.semantic.error};
  border-radius: 8px;
  font-size: 10px;
  font-family: ${({ theme }) => theme.fonts.component.buttonLink};
  margin-right: 0;
  margin-left: auto;
`

export const ModalCloseIcon = styled(IconButton)`
  color: ${({ theme }) => theme.colors.grayscale.black};
  margin-left: auto;
  margin-right: 0;
  padding: 0;
  &.MuiIconButton-root:hover {
    background-color: inherit;
  }
`

export const ModalTitle = styled(DialogTitle)`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
  margin-bottom: 12px;
  background-color: ${({ theme }) => theme.colors.grayscale.white};
`

export const SubmitDocumentsButton = styled(PrimaryButton)`
  --btn-line-height: 19px;
  width: 100%;
  max-height: 50px;
  margin-bottom: 8px;
  margin-top: 12px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 16px;
  font-weight: 700;
  text-transform: none;
  background-color: ${({ theme }) => theme.colors.brandBlue.main};
  color: ${({ theme }) => theme.colors.grayscale.white};
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:hover {
    background-color: #0b2648cc;
  }
`

export const RemindButton = styled(SecondaryButton)`
  --btn-line-height: 19px;
  width: 100%;
  max-height: 50px;
  margin-bottom: 8px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 16px;
  font-weight: 700;
  text-transform: none;
  border: 1px solid ${({ theme }) => theme.colors.grayscale.black};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.brandBlue.main};
`

export const OptOutButton = styled(SecondaryButton)`
  --btn-line-height: 19px;
  width: 100%;
  max-height: 50px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 16px;
  font-weight: 700;
  text-transform: none;
  border: 1px solid ${({ theme }) => theme.colors.semantic.error};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.semantic.error};
  &:hover {
    background-color: ${({ theme }) => theme.colors.semantic.error};
    color: ${({ theme }) => theme.colors.grayscale.white};
  }
`
